import styled, { css } from 'styled-components';
import { Button, TextField } from '@tryhackme/thm-ui-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const StyledAddIcon = styled(FontAwesomeIcon)`
  && {
    height: 1.9rem;
    width: 1.4rem;
  }
`;

export const StyledRecords = styled.div`
  display: grid;
  justify-content: flex-start;
  grid-template-columns: 1fr 1fr;
`;

export const HeadingWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: 1rem;
  margin-bottom: 2rem;
`;

export const StyledButtonIcon = styled(FontAwesomeIcon)`
  && {
    height: 1.9rem;
    width: 1.4rem;
    padding: 0rem;
    margin: -0.5rem;
  }
`;

export const StyledSubscriberField = styled(TextField)`
  @media screen and (min-width: ${({ theme }) => theme.sizes.xs}) {
    width: 26.5rem;
  }

  @media screen and (width: ${({ theme }) => theme.sizes.md}) {
    width: 50rem;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    width: 16rem;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.xl}) {
    width: 34rem;
  }
`;

export const StyledHeading = styled.span`
  margin: 0;
  font-size: 2.4rem;
  font-weight: ${({ theme }) => theme.fonts.weight.bold};
  color: ${({ theme }) => theme.colors.text.main};
`;

export const StyledImage = styled.div`
  margin-right: 1rem;
  margin-top: 0rem;
  display: inline-block;
  vertical-align: middle;
`;

const tabletMediaQuery = css`
  @media screen and (max-width: 82rem) {
    flex-direction: column;
    align-items: center;
    font-size: ${({ theme }) => theme.fonts.sizes.default};
  }
`;

export const StyledFilters = styled.div`
  display: grid;
  align-items: center;

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    row-gap: 0.5rem;
    text-align: left;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    grid-template-columns: 40% 1fr;
  }

  @media screen and (width: ${({ theme }) => theme.sizes.md}) {
    grid-template-columns: 1fr;
  }
`;

export const StyledCompanyBarWrapper = styled.div`
  display: flex;
  justify-content: space-between;

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    flex-direction: column;
    gap: 1rem;
    align-items: center;
  }
`;

export const StyledFontAwesomeIcon = styled(FontAwesomeIcon)`
  margin-right: 1.2rem;
  margin-top: -1rem;
  display: inline-block;
  vertical-align: middle;
  color: ${({ theme }) => theme.colors.info.main};
  width: 3rem;
  height: 3rem;
`;

export const StyledSearch = styled.span`
  flex: 1;
  text-align: left;
  color: ${({ theme }) => theme.colors.text.main};
  display: flex;

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    flex: none;
  }
`;

export const StyledDropDown = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    margin-top: 1rem;
    justify-content: flex-start;
  }
`;

export const StyledSize = styled.span`
  margin-right: 1rem;
  margin-left: 1rem;
  font-size: large;
  color: ${({ theme }) => theme.colors.text.main};
`;

export const StyledSelect = styled.div`
  display: inline-block;
  vertical-align: middle;
  max-width: 8rem;
  width: 100%;
  text-align: left;
`;

export const StyledCompanyField = styled.div`
  max-width: 25rem;
  width: 100%;
  text-align: left;
`;

export const StyledNoRecordMessage = styled.p`
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => theme.colors.text.light};
`;

export const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    justify-content: center;
  }
`;

export const StyledText = styled.div`
  display: grid;
  justify-content: flex-start;
  margin-bottom: 6rem;
  width: 100%;
  text-align: left;
  color: ${({ theme }) => theme.colors.paragraph};

  span {
    color: ${({ theme }) => theme.colors.info.main};
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    justify-content: center;
    margin-bottom: 2rem;
  }
`;

export const StyledPagination = styled.div`
  display: grid;
  justify-content: flex-end;
  margin-bottom: 2rem;

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    grid-row: 2;
  }

  @media (max-width: 132rem) {
    justify-content: center;
  }
`;

export const StyledTabHeading = styled.span`
  font-size: 2rem;
  padding: 0.6rem;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
`;

export const StyledTabHead = styled.div`
  flex: 50;
`;

export const StyledHeadButton = styled.div`
  flex: 50;
  text-align: end;
`;

export const UsersInfo = styled.div`
  align-content: left;

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) and (max-width: ${({ theme }) => theme.sizes.lg}) {
    width: 100%;
  }
`;

export const ContentBox = styled.div`
  display: flex;
`;

export const StyledDownload = styled.div`
  margin-right: 1.5rem;

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    margin-right: 0;
  }
`;

export const CorpMainPage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.8rem;
  align-self: stretch;
  padding: 3rem 2rem 6rem 2rem;

  @media screen and (min-width: ${({ theme }) => theme.sizes.xs}) {
    padding: 1rem 0 0;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    padding: 1rem;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    padding: 2rem 2rem 6rem 2rem;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.xl}) {
    padding: 0 10rem 6rem 10rem;
  }
  ${tabletMediaQuery}
`;

export const CorpContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2.4rem;
  align-self: stretch;
  align-items: center;
  justify-content: center;

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    margin-top: 1.8rem;
    flex-direction: row;
    align-items: flex-start;
  }
`;

export const CorpColumns = styled.div`
  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    // width: 80%;
  }

  ${tabletMediaQuery}
`;

export const CorpSideButton = styled(Button)`
  display: flex;
  flex-direction: row;
  gap: 1rem;
  width: 100%;
  border-radius: 0.4rem;
  background: ${({ theme }) => theme.colors.button.close.background};
  margin-top: 1rem;

  @media screen and (max-width: ${({ theme }) => theme.sizes.lg}) {
    margin-bottom: 0;
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    margin-bottom: 0;
    margin-left: 0;
    white-space: nowrap;
  }
`;

export const StyledSidePanelFormToggleRow = styled.label`
  display: flex;
  height: 2.9rem;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  margin: 0.9rem 0 0 0.5rem;

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    margin-right: 0.5rem;
    margin-left: 0.8rem;
  }
`;

export const StyledSidePanelText = styled.p`
  font-size: ${({ theme }) => theme.fonts.sizes.small};
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  line-height: 1rem;
  margin-left: -0.5rem;
  color: ${({ theme }) => theme.colors.text.main};

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    font-size: ${({ theme }) => theme.fonts.sizes.small};
  }
`;

export const StyledCorpButtonsHeader = styled.div`
  right: 2.6rem;
  top: 2.6rem;
  display: flex;
  justify-content: flex-end;
  font-size: 2.4rem;
  cursor: pointer;

  & > button > svg {
    width: 2rem;
    height: 2rem;
  }
`;

export const StyledEmptySeats = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3.7rem;
  height: 3.5rem;
  border-radius: 2.3rem;
  font-size: 1.4rem;
  font-family: ${({ theme }) => theme.fonts.familyUbuntu};

  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ theme }) => theme.colors.secondary.main};
  padding: 1rem 1.6rem;
  border: 0.01rem solid ${({ theme }) => theme.colors.grey[600]};

  @media screen and (min-width: ${({ theme }) => theme.sizes.xs}) {
    margin-left: 0.5rem;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    margin: 0 1rem 0 2rem;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    margin: 0rem 1rem 0rem 0rem;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.xl}) {
    margin: 0rem 1rem 0rem 11rem;
  }
`;

export const StyledTextField = styled(TextField)`
  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    width: 34rem;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) and (max-width: 68.1rem) {
    width: 42.5rem;
  }

  @media screen and (max-width: 42.5rem) {
    width: 25rem;
  }
`;
